export const PUMP_SIZES = {
  specificSizeCode: '5',
  anySizeCode: '92',
};

export const PUMP_FLOW_UNIT = {
  m3h: 'm3/h',
};
